var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g(_vm._b({class:['v-textarea', _vm.isError && 'v-textarea--error'],attrs:{"cols":_vm.cols,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}},'textarea',_vm.$attrs,false),_vm.inheritListeners))}
var staticRenderFns = []

export { render, staticRenderFns }